/**
 * Denominations the Canadian tax path rates in — mirrors
 * `CANADIAN_TAX_CURRENCIES` in svc/listing's `tax-candidates.ts` (FP-3012).
 */
const CANADIAN_TAX_CURRENCIES = new Set(['CAD', 'USD'])

// Taxability follows the addresses, not the denomination: a CA→CA supply is
// taxable whether the listing prices it in CAD or USD. GBP/EUR stay excluded —
// svc/listing yields no candidate for them.
const isCanadianTaxCurrency = (currency?: string): boolean =>
  !!currency && CANADIAN_TAX_CURRENCIES.has(currency.toUpperCase())

export default isCanadianTaxCurrency
